/**
 * Accordion tab web component. Open state and exclusive groups are handled in JS;
 * expand/collapse animation is handled in CSS via the accordion-panel grid pattern.
 */
class AccordionTab extends HTMLElement {
  constructor() {
    super();
    this.titleSelector = this.querySelector('.tab');
    this.bodySelector = this.querySelector('.tab-content');
  }

  connectedCallback() {
    if (!this.titleSelector || !this.bodySelector) return;

    if (!this._clickHandler) {
      this._clickHandler = () => this.toggleOpenState();
      this.titleSelector.addEventListener('click', this._clickHandler);
    }

    this._openFirstTabIfNeeded();
  }

  disconnectedCallback() {
    this.titleSelector?.removeEventListener('click', this._clickHandler);
    this._clickHandler = null;
  }

  /**
   * Opens the first tab when no accordion in the document is open.
   */
  _openFirstTabIfNeeded() {
    const allTabs = document.querySelectorAll('accordion-tab');
    const anyTabOpen = Array.from(allTabs).some((tab) => tab.hasAttribute('open'));

    if (!anyTabOpen && allTabs[0] === this) {
      this.open();
    }
  }

  /**
   * Toggles this tab and closes other open tabs in the same document.
   */
  toggleOpenState() {
    if (this.hasAttribute('open')) {
      this.close();
      return;
    }

    document.querySelectorAll('accordion-tab').forEach((element) => {
      if (element !== this && element.hasAttribute('open')) {
        element.close();
      }
    });

    this.open();
  }

  /**
   * Opens this accordion tab.
   */
  open() {
    this.setAttribute('open', '');
    this._updateBoutiqueMenuState();
  }

  /**
   * Closes this accordion tab.
   */
  close() {
    this.removeAttribute('open');
    this._updateBoutiqueMenuState();
  }

  /**
   * Syncs boutique menu styling when accordions live inside .boutique-menu.
   */
  _updateBoutiqueMenuState() {
    const menu = this.closest('.boutique-menu');
    if (!menu) return;

    menu.classList.toggle('open', Boolean(menu.querySelector('accordion-tab[open]')));
  }
}

if (!customElements.get('accordion-tab')) {
  customElements.define('accordion-tab', AccordionTab);
}
